/*
 * @Author: your name
 * @Date: 2022-03-08 15:09:45
 * @LastEditTime: 2022-03-15 16:33:38
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\pages\personal\changemobile\locales.ts
 */
export const EnumPageMeta: IEnumPageMeta = {
    /** 页面名称 */
    title: "更换手机",
    login: true,
    layout: 'personal'
}
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {
    /** 姓名 */
    endpoint = "changemobile.endpoint",
    imgCode = "changemobile.imgCode",
    verificationCode= "changemobile.verificationCode",
    mobile="changemobile.mobile",
    mobileCode="changemobile.mobileCode",
    captcha="changemobile.captcha"
}
export enum EnumGender {

}
export default {
    en: {
        [EnumLocaleLabel.endpoint]: 'endpoint',
        [EnumLocaleLabel.imgCode]: 'imgCode',
        [EnumLocaleLabel.verificationCode]: 'verificationCode',
        [EnumLocaleLabel.mobile]: 'mobile',
        [EnumLocaleLabel.mobileCode]: 'mobileCode',
        [EnumLocaleLabel.captcha]: 'captcha',
    },
    zh: {
        [EnumLocaleLabel.endpoint]: '验证旧手机',
        [EnumLocaleLabel.imgCode]: '图形验证码',
        [EnumLocaleLabel.verificationCode]: '短信验证码',
        [EnumLocaleLabel.mobile]: '新手机',
        [EnumLocaleLabel.mobileCode]: '短信验证码',
        [EnumLocaleLabel.captcha]: '图形验证码',
    }
}